import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Box, Divider, Grid, Typography, TextField, FormControlLabel, Switch } from '@mui/material';
import { Button } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import { i18n } from '../../../translate/i18n';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import toastError from '../../../errors/toastError';
import api from '../../../services/api';
import SingleSelect from '../../InputStyled/singleSelect';
import * as Yup from "yup";
import * as XLSX from 'xlsx';

const Transition = React.forwardRef(function Transition(
    props,
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "7px",
        float: "right",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "& svg": {
            color: theme.palette.primary.contrastText,
            marginRight: '5px'
        },
    },
}));

const ImportWhatsappMessageStoreModal = ({ open, onClose, id }) => {

    const classes = useStyles();
    const fullWidth = true;
    const maxWidth = 'sm';
    const [loading, setLoading] = useState(false);
    const [connections, setConnections] = useState([]);
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const initialState = {
        id: "",
        name: "",
        connectionId: "",
    };
    const [register, setRegister] = useState(initialState);


    useEffect(() => {
        if (open != true) return;

        (async () => {
            try {
                const { data: wp } = await api.get(`/whatsappListByUser`);
                if (Array.isArray(wp)) setConnections(wp.filter(w => w.moduleId == true));
            } catch (err) {
                console.error({ err });
                toastError(err);
            }
            if (!id || id == '' || id == 'undefined') return;
            try {
                const { data } = await api.get(`/whatsapp/importMessageHistory/show/${id}`);
                if (data) setRegister(data);
            } catch (err) {
                console.error(err);
                toastError(err);
            } finally {
                setLoading(false);
            }
        })();

    }, [open]);

    const RegisterSchema = Yup.object().shape({
        name: Yup.string()
            .required(`${i18n.t("contacts.validateContacts.name")} ${i18n.t("contacts.validateContacts.required")}`),
        connectionId: Yup.string()
            .required(`${i18n.t("contacts.validateContacts.connection")} ${i18n.t("contacts.validateContacts.required")}`),
    });

    // reordenar para seguir sequencia correta
    if (RegisterSchema['_nodes']) RegisterSchema['_nodes'] = RegisterSchema['_nodes'].reverse();

    const handleClose = (event, reason) => {

        if (reason == 'backdropClick') {
            event.preventDefault();
            return;
        }

        setRegister(initialState);
        setFiles([]);
        if (fileInputRef.current) fileInputRef.current.value = '';
        onClose();
    }

    const processSheetData = async (file) => {
        const numbers = [];

        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: 'array' });

            for (const sheetName of workbook.SheetNames) {
                const sheet = workbook.Sheets[sheetName];
                const rows = XLSX.utils.sheet_to_json(sheet);

                for (const row of rows) {
                    const phoneNumber = row.numero || row.number || row.phoneNumber;
                    if (phoneNumber && !numbers.includes(phoneNumber)) {
                        numbers.push(phoneNumber);
                    }
                }
            }
        } catch (err) {
            console.error('Erro ao processar o arquivo Excel:', err);
        }

        return numbers;
    };


    const handleSave = async () => {
        let validated = false;

        try {
            setLoading(true);
            await RegisterSchema.validate(register);
            validated = true;

            // verificar arquivo
            if (!files || files?.length == 0) {
                toast.error(`${i18n.t("contacts.validateContacts.file")} ${i18n.t("contacts.validateContacts.required")}`);
                return;
            }

            const phoneNumbers = await processSheetData(files[0]);

            // cadastrar
            await api.post('/contacts/searchAndValidateContact', {
                ...register,
                contacts: phoneNumbers
            });

            setTimeout(() => {
                handleClose();
                toast.success(i18n.t("contacts.validateContacts.savedSuccesfully"));
                setLoading(false);
            }, 500);

        } catch (err) {
            if (validated == false) toast.error(err?.message ? i18n.t(err.message) : 'INTERNAL_ERROR');
            else toast.error(err?.response?.data?.message ? i18n.t(err.response.data.message) : 'INTERNAL_ERROR');
            setLoading(false);
        }
    }

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setFiles(files);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!fileInputRef || !fileInputRef?.current?.accept) return;

        const files = Array.from(event.dataTransfer.files);
        if (files.length > 1) return;
        // Extensões permitidas
        const acceptedFormats = fileInputRef.current.accept.split(',');

        // Filtra os arquivos aceitos com base nas extensões
        const validFiles = files.filter((file) => {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            return acceptedFormats.includes(`.${fileExtension}`);
        });

        if (validFiles.length == 0) {
            toast.error(i18n.t("Formato de arquivo inválido."));
            return;
        }

        setFiles(files);
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Dialog
            open={open == true ? true : false}
            TransitionComponent={Transition}
            keepMounted
            onClose={(event, reason) => handleClose(event, reason)}
            aria-describedby="alert-dialog-slide-template"
            disableEscapeKeyDown={true}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle>
                {!id ? i18n.t("contacts.validateContacts.storeTitle") : i18n.t("contacts.validateContacts.editTitle")}
                <Button
                    onClick={(e) => {
                        e.preventDefault();

                        (async () => {
                            try {
                                setLoading(true);
                                // Cria uma nova planilha
                                const worksheet = XLSX.utils.json_to_sheet([{ numero: "" }]);
                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                                // Converte o workbook para binário
                                const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

                                // Define o nome do arquivo
                                const fileName = "ValidacaoContatos.xlsx";

                                // Função auxiliar para converter string em buffer
                                const s2ab = (s) => {
                                    const buf = new ArrayBuffer(s.length);
                                    const view = new Uint8Array(buf);
                                    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                                    return buf;
                                };

                                // Cria um blob a partir do buffer
                                const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });

                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.style.display = 'none';
                                a.href = url;
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(url);

                                // Remove o link e libera o objeto URL
                                window.URL.revokeObjectURL(url);
                                document.body.removeChild(a);
                            } catch (err) {
                                console.error({ err });
                                toastError(err);
                            } finally {
                                setLoading(false);
                            }
                        })();
                    }}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    style={{ float: "right" }}
                >
                    {i18n.t("contacts.validateContacts.buttons.modelDownload")}
                </Button>
                <Divider sx={{ marginTop: "10px" }} />
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <Typography
                            component="label"
                            sx={{ fontSize: "1.1rem", marginBottom: "10px", display: "block" }}
                        >
                            {i18n.t("contacts.validateContacts.name")} <Typography color="error" component="span">*</Typography>
                        </Typography>
                        <TextField
                            id="validateContactName"
                            variant="outlined"
                            value={register.name}
                            fullWidth
                            onChange={(e) => {
                                e.preventDefault();
                                const val = e.target?.value || "";
                                setRegister((prevState) => ({
                                    ...prevState,
                                    name: val
                                }));
                            }}
                            inputProps={{ maxLenght: 100 }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <SingleSelect
                            id="validateContactConnection"
                            title={
                                <Typography
                                    component="label"
                                    sx={{ fontSize: '1.1rem', marginBottom: '10px' }}
                                >
                                    {i18n.t("contacts.validateContacts.connection")} <Typography color="error" component="span">*</Typography>
                                </Typography>
                            }
                            displayText={i18n.t("contacts.validateContacts.selectConnection")}
                            options={connections.map((q) => ({ key: q.id, value: q.name }))}
                            onSelected={(opt) => {
                                setRegister((prevState) => ({
                                    ...prevState,
                                    connectionId: opt
                                }));
                            }}
                            selected={register.connectionId}
                            closeOnSelect={true}
                            style={{
                                height: '37px',
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <Box
                            component="div"
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                            sx={{
                                border: '2px dashed',
                                borderColor: (theme) => theme.palette.mode === 'dark' ? '#424242' : '#bdbdbd',
                                color: (theme) => theme.palette.text.primary,
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#616161' : '#eeeeee',
                            }}
                        >
                            {files.length == 1 &&
                                <Typography variant="h6">{files[0].name}</Typography>
                            }
                            <Typography component="p" sx={{ marginBottom: "20px" }}>{i18n.t("contacts.validateContacts.dragText")}</Typography>
                            <Button
                                type="button"
                                onClick={handleButtonClick}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                {i18n.t("contacts.validateContacts.selectFile")}
                            </Button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                accept={".xlsx,.xls,.xlsm, xlsb"}
                                onChange={handleFileChange}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        handleClose();
                    }}
                    variant="outlined"
                    color="error"
                    disabled={loading}
                >
                    {i18n.t("contacts.validateContacts.buttons.close")}
                </Button>
                <Button
                    onClick={() => {
                        handleSave();
                    }}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                >
                    {i18n.t("contacts.validateContacts.buttons.save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ImportWhatsappMessageStoreModal;